import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import authService from "../../services/authService";
import contractApi from "../../services/contractApi";
export const getAgencyList = createAsyncThunk(
  "contract/getAgencyList",
  async (props, thunkAPI) => {
    try {
      const data = await contractApi.getAgencyApi(props);
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getItemTypeList = createAsyncThunk(
  "contract/getItemTypeList",
  async (props, thunkAPI) => {
    try {
      const data = await contractApi.getItemTypeListApi(props);
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getItemDescriptionAndPrice = createAsyncThunk(
  "contract/getItemDescriptionAndPrice",
  async (props, thunkAPI) => {
    try {
      const data = await contractApi.getItemDescriptionAndPriceApi(props);
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getContractCategory = createAsyncThunk(
  "contract/getContractCategory",
  async (props, thunkAPI) => {
    try {
      const data = await contractApi.getcontractCategoryApi(props);
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getContractInvoiceDetails = createAsyncThunk(
  "contract/getContractInvoiceDetails",
  async (props, thunkAPI) => {
    try {
      const data = await contractApi.getContractInvoiceDetailsApi(props);
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getContractDetails = createAsyncThunk(
  "contract/getContractDetails",
  async (props, thunkAPI) => {
    try {
      const data = await contractApi.getContractDetailsApi(props);
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getInvoiceList = createAsyncThunk(
  "contract/getInvoiceList",
  async (props, thunkAPI) => {
    try {
      const data = await contractApi.getInvoiceListApi(props);
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getInvoiceStatus = createAsyncThunk(
  "contract/getInvoiceStatus",
  async (thunkAPI) => {
    try {
      const data = await contractApi.getInvoiceStatusApi();
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getContractList = createAsyncThunk(
  "contract/getContractList",
  async (props, thunkAPI) => {
    try {
      const data = await contractApi.getContractListApi(props);
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const createContract = createAsyncThunk(
  "contract/createContract",
  async (props, thunkAPI) => {
    try {
      const data = await contractApi.createContractApi(props);
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const addPayment = createAsyncThunk(
  "contract/addPayment",
  async (props, thunkAPI) => {
    try {
      const data = await contractApi.addPaymentApi(props);
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const approvePayment = createAsyncThunk(
  "contract/approvePayment",
  async (props, thunkAPI) => {
    try {
      const data = await contractApi.approvePaymentApi(props);
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const voidPayment = createAsyncThunk(
  "contract/voidPayment",
  async (props, thunkAPI) => {
    try {
      const data = await contractApi.voidPaymentApi(props);
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const fetchContractCategory = createAsyncThunk(
  "contract/fetchContractCategory",
  async (props, thunkAPI) => {
    try {
      const data = await contractApi.fetchContractCategoryApi(props);
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
const initialState = {
  response: null,
  agencyList: [],
  itemTypeList: [],
  invoiceStatus: [],
  itemTypeDiscriptionAndPrice: [],
  contractCategory: [],
  contractCategoryLists: [],
  invoiceList: [],
  contractList: [],
  contractDetails: null,
  contractProcessingDetails: null,
};
const contractSlice = createSlice({
  name: "contract",
  initialState,
  extraReducers: {
    [getAgencyList.fulfilled]: (state, action) => {
      state.agencyList = action.payload.response.data;
    },
    [getAgencyList.rejected]: (state) => {
      state.agencyList = [];
    },
    [getItemTypeList.fulfilled]: (state, action) => {
      state.itemTypeList = action.payload.response.data;
    },
    [getItemTypeList.rejected]: (state) => {
      state.itemTypeList = [];
    },
    [getItemDescriptionAndPrice.fulfilled]: (state, action) => {
      state.itemTypeDiscriptionAndPrice = action.payload.response.data;
    },
    [getItemDescriptionAndPrice.rejected]: (state) => {
      state.itemTypeDiscriptionAndPrice = [];
    },
    [getContractCategory.fulfilled]: (state, action) => {
      state.contractCategory = action.payload.response.data;
    },
    [getContractCategory.rejected]: (state) => {
      state.contractCategory = [];
    },
    [fetchContractCategory.fulfilled]: (state, action) => {
      state.contractCategoryLists = action.payload.response.data;
    },
    [fetchContractCategory.rejected]: (state) => {
      state.contractCategoryLists = [];
    },
    [getInvoiceList.fulfilled]: (state, action) => {
      state.invoiceList = action.payload.response.data;
    },
    [getInvoiceList.rejected]: (state) => {
      state.invoiceList = [];
    },
    [getInvoiceStatus.fulfilled]: (state, action) => {
      state.invoiceStatus = action.payload.response.data;
    },
    [getInvoiceStatus.rejected]: (state) => {
      state.invoiceStatus = [];
    },
    [getContractList.fulfilled]: (state, action) => {
      state.contractList = action.payload.response.data;
    },
    [getContractList.rejected]: (state) => {
      state.contractList = [];
    },
    [getContractInvoiceDetails.fulfilled]: (state, action) => {
      state.contractDetails = action.payload.response.data;
    },
    [getContractDetails.fulfilled]: (state, action) => {
      state.contractProcessingDetails = action.payload.response.data;
    },
    [getContractDetails.rejected]: (state) => {
      state.contractProcessingDetails = null;
    },
  },
});
const { reducer } = contractSlice;
export default reducer;
